import { isReactClass } from '../is-react';
export function isDynamicSetter(obj) {
  return obj && typeof obj === 'function' && !isReactClass(obj);
}